import { ChevronDownV2 } from 'src/shared/design-system/Icon';
import { Clickable } from 'src/shared/design-system/Utilities';
import { VerticallyCenteredText } from 'src/shared/design-system/VerticallyCenteredText';
import styled, { css } from 'styled-components';
import { ifProp } from 'web-common/src/shared/styled-utils/ifProp';
import { Border, Colors, Font, Mixins, Spacing, Transition } from 'web-common/src/shared/styles';

export const Button = styled(Clickable)<{
  isActive?: boolean;
  order: number;
  show: boolean;
  isDockedOnDesktop: boolean;
  hasSelection: boolean;
}>`
  background: ${ifProp('hasSelection', Colors.KOHLRABI_LITE_40, Colors.GRAY_LITE_20)};
  border-radius: ${Border.Radius.M};
  cursor: pointer;
  padding: ${Spacing.QUARTER} ${Spacing.THREE_QUARTERS};
  border: 1px solid
    ${ifProp('hasSelection', Colors.KOHLRABI_DARK_10, ifProp('isActive', Colors.GRAY_DARK_20, 'transparent'))};
  white-space: nowrap;

  ${({ order }) =>
    css`
      order: ${order};
    `}

  ${({ isDockedOnDesktop }) => Mixins.Media.minWidthLarge(isDockedOnDesktop ? 'transform: translateY(0);' : '')}
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: ${Font.Size.S};
  gap: ${Spacing.QUARTER};
`;

export const TextWrapper = VerticallyCenteredText;

export const ArrowContainer = styled.div<{ isActive?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  & svg {
    width: ${Spacing.SINGLE};
  }

  transform: ${ifProp('isActive', 'rotate(180deg)', 'rotate(0deg)')};
  transition: transform ${Transition.Time.BASE};
`;

export const Arrow = ChevronDownV2;

export const QuantityWrapper = styled(VerticallyCenteredText)`
  line-height: 0;
`;

export const QuantityBadge = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: ${Colors.GRAY_DARK_30};
  border-radius: ${Spacing.SINGLE};
  color: ${Colors.WHITE};
  font-family: ${Font.Family.SANS};
  font-size: ${Font.Size.XXXS};
  height: ${Spacing.SINGLE};
  width: ${Spacing.SINGLE};
  padding: 1px;
`;
